<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') ||
                  '费用单号/业务人员/客户名称/供应商名称/付款公司 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="175px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_search_amzExpenseStatus') || '单据状态'"
            >
              <el-checkbox-group v-model="form.amzExpenseStatusList">
                <el-checkbox label="N">{{
                  $l('form_label_amzExpenseStatus_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('form_label_amzExpenseStatus_S') || '已提交'
                }}</el-checkbox>
                <el-checkbox label="R">{{
                  $l('form_label_amzExpenseStatus_R') || '已驳回'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('form_label_amzExpenseStatus_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('form_label_amzExpenseStatus_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzExpenseNo') || '费用单号'">
              <el-input
                v-model.trim="form.amzExpenseNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                v-model="form.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payeeScmCode') || '收款供应商'"
              prop="payeeScmCode"
            >
              <dict-select
                v-model="form.payeeScmCode"
                url="/master/common/dict/allScmCooperated"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payeeCustCode') || '收款客户'"
              prop="payeeCustCode"
            >
              <dict-select
                v-model="form.payeeCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_paymentMethod') || '付款方式'">
              <dict-select
                v-model="form.paymentMethodList"
                :body="paymentMethodParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_expensePayerCode') || '付款公司'"
            >
              <dict-select
                v-model="form.expensePayerCode"
                :body="expensePayerParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_oaExpenseProcess') || 'OA申请方式'" prop="requestDate">
              <dict-select
                v-model="form.oaExpenseProcess"
                url="/master/common/dict/biz"
                :body="{ dictType: 'oaExpenseProcess' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_payeeType') || '收款方'"
              prop="payeeType"
            >
              <dict-select
                v-model="form.payeeType"
                url="/master/common/dict/biz"
                :body="payeeTypeParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_requestDate') || '申请日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  amzExpenseStatusList: ['N', 'S', 'R', 'Y'],
}
export default {
  data() {
    return {
      userReimbursementStatusParams: { dictType: 'userReimbursementStatus' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      expensePayerParams: { dictType: 'expensePayer' },
      costCategoryParams: { dictType: 'costCategory' },
      payeeTypeParams: { dictType: 'payeeType' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      selectOptions: [
        { label: this.$l('INDEX.YES') || '是', value: '0' },
        { label: this.$l('INDEX.NO') || '否', value: '1' },
      ],
      //申请日期限制
      requestDateStartPicker: this.requestDateEnd(),
      requestDateEndPicker: this.requestDateStart(),
      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),
      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    requestDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endRequestDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endRequestDate).getTime() < time.getTime()
          }
        },
      }
    },
    requestDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginRequestDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginRequestDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
